<mat-card
  appearance="outlined"
  class="intro"
>
  @if (logoSrc(); as logo) {
    <img
      class="logo"
      [ngSrc]="logo"
      width="56"
      height="56"
      alt=""
    />
  }
  <div>
    <h2 class="app-name">{{ appName() }}</h2>
    <p>{{ description() }}</p>
  </div>
</mat-card>

<mat-card
  appearance="outlined"
  class="section"
>
  <div class="section-head">
    <h2 class="section-title">Version</h2>
    <span
      class="env-badge"
      [class.production]="isProduction()"
      >{{ environmentLabel() }}</span
    >
  </div>

  <dl class="details">
    <dt>Version</dt>
    <dd>
      <span class="mono">{{ version() }}</span>
      @if (versionDescription(); as description) {
        <span class="muted"> · {{ description }}</span>
      }
    </dd>
    <dt>Release</dt>
    <dd class="mono">{{ release() }}</dd>
    @if (firebaseProject(); as project) {
      <dt>Firebase project</dt>
      <dd class="mono">{{ project }}</dd>
    }
    <dt>Angular</dt>
    <dd class="mono">{{ angularVersion }}</dd>
    @if (hasServiceWorker) {
      <dt>Updates</dt>
      <dd aria-live="polite">
        @if (!updatesEnabled) {
          <span class="muted">Automatic updates are off in development builds.</span>
        } @else {
          @switch (updateStatus()) {
            @case ("checking") {
              Checking…
            }
            @case ("current") {
              You're on the latest version.
            }
            @case ("ready") {
              A new version is ready.
            }
            @case ("error") {
              Couldn't check for updates. Try again later.
            }
            @default {
              <span class="muted">Checked automatically while the app is open.</span>
            }
          }
        }
      </dd>
    }
  </dl>

  <div class="actions">
    @if (updateStatus() === "ready") {
      <button
        mat-flat-button
        (click)="reload()"
      >
        <mat-icon>refresh</mat-icon>
        Reload to update
      </button>
    } @else if (updatesEnabled) {
      <button
        mat-stroked-button
        [disabled]="updateStatus() === 'checking'"
        (click)="checkForUpdate()"
      >
        <mat-icon>system_update_alt</mat-icon>
        Check for updates
      </button>
    }
    <button
      mat-stroked-button
      (click)="copyDetails()"
    >
      <mat-icon>content_copy</mat-icon>
      Copy details
    </button>
  </div>
  <p class="hint">Copy details puts the details on this page and your browser on the clipboard for support requests.</p>
</mat-card>

@for (section of sections(); track section.title) {
  <mat-card
    appearance="outlined"
    class="section"
  >
    <h2 class="section-title">{{ section.title }}</h2>
    <dl class="details">
      @for (item of section.items; track item.label) {
        <dt>{{ item.label }}</dt>
        <dd>{{ item.value }}</dd>
      }
    </dl>
  </mat-card>
}
